import { render, staticRenderFns } from "./Desossa.vue?vue&type=template&id=747d109b&scoped=true&"
import script from "./Desossa.vue?vue&type=script&lang=js&"
export * from "./Desossa.vue?vue&type=script&lang=js&"
import style0 from "./Desossa.vue?vue&type=style&index=0&id=747d109b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d109b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VImg})
